import axios from "./api";
class PermissionService {
  getAll() {
    return axios.get(`/permissions`);
  }
  get(id) {
    return axios.get(`/permissions/${id}`);
  }
  create(data) {
    return axios.post(`/permissions`, data);
  }
  assignPermission(role, data) {
    return axios.post(`/permissions/${role}/assignPermission`, data);
  }
  revokePermission(role, data) {
    return axios.post(`/permissions/${role}/revokePermission`, data);
  }
  update(id, data) {
    return axios.put(`/permissions/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/permissions/${id}`);
  } 
  restore(id) {
    return axios.post(`/permissions_restore/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new PermissionService();
